<template>
	<div>
		<!--<div class="maincat__filter">Параметры фильтра:</div>-->
		<pagin-component :items="opravas"></pagin-component>
		<ul class="uk-child-width-1-2@s uk-child-width-1-3@m uk-grid-match uk-grid-small" uk-grid v-if="opravas.data && opravas.data.length > 0">
			<li v-for="item in opravas.data">
				<div>
					<cat-card :item="item" :key="item.id" :user="user" :prepay="getUserPrepay"></cat-card>
				</div>
			</li>
		</ul>
		<div class="maincat__notfound" v-else>Ничего не найдено. Попробуйте изменить запрос</div>
		<div class="maincat__loadmore" v-if="list.length < opravas.length">
			<button class="uk-button uk-button-primary" @click="addToItems">ПОКАЗАТЬ ЕЩЕ</button>
		</div>
		<wait></wait>
		<pagin-component :items="opravas"></pagin-component>
	</div>
</template>

<script>
  import { bus } from './bus.js'
  import wait from './wait'
  import { finance } from "../mixins/finance";
  import paginComponent from "./pagination";

  export default {
    name: "category",
    mixins: [finance],
    data() {
      return {
        opravas: '',
        list: []
      }
    },
	  components: {wait, paginComponent},
    props: {
      items: '',
      url: '',
	    user: ''
    },
    methods: {
      updateItems(data) {
        //this.list = [];
        this.opravas = data;
        //this.addToItems();
        //console.log(data);
      },
      addToItems() {
        let opravas = this.opravas.data;
        let list = this.list;
        let from = list.length;
        let to = list.length + 40;
        let cuttedOpravas = opravas.slice(from, to);
        //console.log(from, to, cuttedWorks);
        if (opravas.length > 0) {
          this.$set(this, 'list', this.list.concat(cuttedOpravas));
        }
      }
    },
    mounted() {
      bus.$on('filterApplied', this.updateItems);
      this.opravas = this.items;
      //this.addToItems();
    }
  }
</script>


// WEBPACK FOOTER //
// themes/oprava/src/js/components/commerce/category.vue